import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { url } from "../../../Utilities/url";
import { applyReward, getHeaderApi } from "../../../Utilities/controller";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { errors } from "../../../Utilities/error";
import { func } from "../../../Utilities/logFunc";
import { useProfileDataContext } from "../ProfileContext";
import { useTranslation } from "react-i18next";
import { eventTracking } from "../../../firebaseAnalytics";
import { events } from "../../../Utilities/appEvents";
import Loader from "../../Common/Loader";

// ⬇️ NEW: import the rewarded component
import GoogleRewarded from "../../GoogleAds/GoogleRewarded"; // adjust path if needed

const RedeemRewardModal = ({
  redeemRewardModal,
  setRedeemRewardModal,
  activeRedeemReward,
  setActiveTab,
}) => {
  const [show, setShow] = useState(redeemRewardModal);
  const { updateProfileData } = useProfileDataContext();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();

  // ⬇️ NEW: state to trigger rewarded fullscreen
  const [showRewarded, setShowRewarded] = useState(false);

  const handleClose = () => {
    setRedeemRewardModal(false);
    setShow(false);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const data = { product: activeRedeemReward?._id };
      const res = await applyReward(data);

      if (res?.data?.success === true) {
        toast.success(t("success_Redeem_Reward_successfully"));

        const resProfile = await getHeaderApi();
        if (resProfile?.data) {
          eventTracking(events.Redeem_Rewards, {
            GJ_RewardsProductID: activeRedeemReward.rewardCategory,
            GJ_ProdcutName: activeRedeemReward.name,
            GJ_ProductAmount: activeRedeemReward.rewardVoucherAmount,
            GJ_Currency: activeRedeemReward.currency.code,
            GJ_Amount: activeRedeemReward.coinAmount,
          });
          updateProfileData(resProfile?.data);
        }

        // ⬇️ DON'T close yet – show rewarded ad fullscreen
        setShowRewarded(true);
        setLoading(false);
      } else {
        setRedeemRewardModal(false);
        setShow(false);
        setLoading(false);
        func("succe", errors.success_Redeem_Reward_successfully);
        if (res?.response?.data?.errors?.[0]?.msg)
          toast.error(res?.response?.data?.errors?.[0]?.msg);
        if (res?.response?.data?.Error?.[0]?.msg)
          toast.error(res?.response?.data?.Error?.[0]?.msg);
      }
    } catch (error) {
      setRedeemRewardModal(false);
      setShow(false);
      setLoading(false);
      func("succe", errors.success_Redeem_Reward_successfully);
      toast.error(error?.response?.data?.errors?.[0]?.msg);
    }
  };

  // ⬇️ When the rewarded ad closes, THEN finish your UI flow
  const handleRewardedClosed = () => {
    setShowRewarded(false);
    setRedeemRewardModal(false);
    setShow(false);
    setActiveTab?.(2);
  };

  return (
    <>
      {isLoading ? <Loader /> : null}

      {/* ⬇️ Fullscreen rewarded ad trigger */}
      <GoogleRewarded
        adUnitPath="/157165500,23206251223/MCM_Gj_Console/MCM_Gj_Console_rewarded_1"
        show={showRewarded}
        onGranted={() => {
          // optional: toast.success(t("reward_unlocked"));
        }}
        onClosed={handleRewardedClosed}
      />

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="auth-modal modal fade"
        centered
      >
        <Modal.Body>
          <button
            type="button"
            className="btn-close"
            onClick={handleClose}
            aria-label="Close"
          />
          <div className="row justify-content-center">
            <div
              className="col-12 justify-content-center align-items-center"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <h3 className="bodyBoldFont mb-5 text-center text-dark">
                {activeRedeemReward?.name}
              </h3>

              <div className="col-6 d11-logout-text text-dark">
                <p>
                  <img
                    src={url?.imageUrl + activeRedeemReward?.currency?.img?.default}
                    height="20"
                    alt=""
                  />{" "}
                  {activeRedeemReward?.coinAmount}
                </p>
                <p>{activeRedeemReward?.description}</p>
              </div>

              <div className="col-6 fl-center text-dark">
                <button
                  className="btn btn-primary"
                  style={{ width: "50%" }}
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  <p style={{ marginBottom: 0 }}>
                    <img
                      src={url?.imageUrl + activeRedeemReward?.currency?.img?.default}
                      height="20"
                      style={{ verticalAlign: "middle" }}
                      alt=""
                    />{" "}
                    {activeRedeemReward?.coinAmount} Redeem
                  </p>
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RedeemRewardModal;
